import React from 'react';
import { Moon, Sun } from 'lucide-react';

interface ThemeToggleProps {
  theme: 'light' | 'dark';
  onToggle: () => void;
}

export const ThemeToggle = ({ theme, onToggle }: ThemeToggleProps) => {
  return (
    <button
      onClick={onToggle}
      className={`p-2 rounded-full transition-colors duration-200 ${
        theme === 'dark' 
          ? 'text-gray-400 hover:text-white hover:bg-[rgba(255,255,255,0.1)]' 
          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
      }`}
      aria-label="Toggle theme"
    >
      {theme === 'dark' ? (
        <Sun className="w-5 h-5" />
      ) : (
        <Moon className="w-5 h-5" />
      )}
    </button>
  );
};
